import React, { useEffect, useState } from 'react'
import { api } from 'services';
import { Button, Card, Col, Container, Row, Modal, Form, Badge } from 'react-bootstrap';
import { Code, RemoveRedEyeOutlined } from '@material-ui/icons';
import BootstrapTable from 'react-bootstrap-table-next';

import './style.css'

export default function(){
  const [logs, setLogs] = useState([]);
  const [dates, setDates] = useState([]);
  const [date, setDate] = useState("");
  const [logToShow, setLogToShow] = useState({});
  const [showModalLog, setShowModalLog] = useState(false);
  const columnsConfig = {
    headerStyle: {
      textAlign: 'center',
    },
    style: {
      textAlign: 'center',
    }
  };

  useEffect(() => {
    getLogs();
  }, [date])

  const getLogs = () => {
    const badge = {
      INFO: () => <Badge variant='info'>INFO</Badge>,
      ERROR: () => <Badge variant='danger'>ERROR</Badge>
    }
    api.get('/logs', { params: { log_date: date } })
      .then(({ data }) => {
        const { logs: logs_db, available_log_dates, date } = data;
        setDates(available_log_dates);
        setDate(date);
        const logsData = logs_db.map(({ timestamp, env, type, message }, k) => ({
          pos: k,
          timestamp: formatDate(timestamp), 
          env, 
          type: badge[type](),
          message,
          description : buildMessage(message),
          //action: buildAction({ timestamp, env, type, message })
        }))
        setLogs(logsData)
      })
  }

  const buildMessage = message => {
    return <span className='pre'>
      { message }
    </span>
  }

  const buildAction = log => {
    return (
      <Button 
        variant="info" 
        size="sm"
        onClick={() => {
          setLogToShow(log)
          setShowModalLog(true)
        }}
      >
        <RemoveRedEyeOutlined />
      </Button>
    )
  }

  const formatDate = datetime => {
    return new Date(datetime).toLocaleString('pt-Br', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute:'2-digit',
      second:'2-digit'
    })
  }

  return (
    <Container fluid>
      <Row className="mt-4">
        <Code className="icon-title" />
        <h5 className="title-dashboard">Logs</h5>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 p-5 col-12">
          <Row>
            <Col xs="3">
              <Form.Group>
                <Form.Label>Data:</Form.Label>
                <Form.Control
                  value={date}
                  as="select"
                  onChange={(e) => {
                    setDate(e.target.value)
                  }}
                >
                  <option value="" disabled>Selecionar Data</option>
                  {dates.map((item, k) => (
                    <option key={item} value={item}>{ item }</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <BootstrapTable
                style={{ width: '100px' }}
                id="table"
                className="font-10"
                keyField="pos"
                data={logs}
                columns={[
                  {
                    dataField: 'timestamp',
                    text: 'Horário',
                    ...columnsConfig
                  },
                  {
                    dataField: 'env',
                    text: 'Ambiente',
                    ...columnsConfig
                  },
                  {
                    dataField: 'type',
                    text: 'Tipo',
                    ...columnsConfig
                  },
                  {
                    dataField: 'description',
                    text: 'Descrição',
                    ...columnsConfig
                  }
                ]}
                bordered
                striped
                hover
                condensed
              />
            </Col>
          </Row>
        </Card.Body>
        <Modal 
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered 
          show={showModalLog} 
          onHide={() => setShowModalLog(!showModalLog)}
        >
          <Modal.Header closeButton>
            <Modal.Title>{ formatDate(logToShow.timestamp) }</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <Col md="2"><span>Data:</span></Col>
                <Col md="9">
                  <span className="font-weight-bold">{ formatDate(logToShow.timestamp) }</span>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md="2"><span>Ambiente:</span></Col>
                <Col md="9">
                  <span className="font-weight-bold">{ logToShow.env }</span>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md="2"><span>Tipo:</span></Col>
                <Col md="9">
                  <span className="font-weight-bold">{ logToShow.type }</span>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md="2"><span>Descrição:</span></Col>
                <Col md="9">
                  <div style={{width: '100%', position: 'relative'}}>
                    <span className="font-weight-bold">
                      { logToShow.message }
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModalLog(!showModalLog)}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>
    </Container>
  )
}